"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.StyledContainer = void 0;
const styles_1 = require("@mui/material/styles");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
exports.StyledContainer = (0, styles_1.styled)(Box_1.default)(({ theme }) => ({
    backgroundImage: theme.palette.gradient.blue,
    display: "flex",
    width: "100%",
    height: "176px",
    flexWrap: "wrap",
    borderBottom: `2px solid ${theme.palette.institutional.braskemYellow}`,
    alignItems: "flex-end",
    marginBottom: "16px"
}));
exports.Title = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.white,
    width: "100%",
    fontWeight: "bold",
}));
